import { render } from "./Kindesdaten.vue?vue&type=template&id=682c5938&scoped=true"
import script from "./Kindesdaten.vue?vue&type=script&lang=js"
export * from "./Kindesdaten.vue?vue&type=script&lang=js"

import "./Kindesdaten.vue?vue&type=style&index=0&id=682c5938&lang=stylus&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-682c5938"]])

export default __exports__